export default "__VITE_ASSET__B4giXQZ1__"